import React, { useEffect, useState } from "react";
import TopNavigator from "../components/TopNavigator";
import { fetchUserPortalDetails } from "../utils/userPortalApi";

function BalancePage() {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const load = async () => {
      try {
        const data = await fetchUserPortalDetails();
        setDetails(data);
      } catch (err) {
        setError(err.message || "خطا در دریافت موجودی حساب");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const user = details?.user;
  const formatAmount = (value) =>
    Number(value || 0).toLocaleString("fa-IR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });

  return (
    <div className="MainPageShell">
      <TopNavigator />
      <main className="container UserPortalPage">
        <section className="UserPortalHero">
          <span className="MainPageEyebrow">پرتال کاربر</span>
          <h2 className="MainPageTitle">موجودی حساب</h2>
          <p className="MainPageDescription">
            مانده پولی و طلای حساب شما در این بخش نمایش داده می‌شود.
          </p>
        </section>

        <section className="UserPortalPanel">
          {loading ? (
            <p className="UserPortalEmpty">در حال دریافت اطلاعات...</p>
          ) : error ? (
            <p className="UserPortalEmpty UserPortalError">{error}</p>
          ) : (
            <>
              {details?.fallback && (
                <p className="UserPortalNotice">
                  جزئیات کامل تراکنش‌ها از بک دریافت نشد و فقط اطلاعات پایه کاربر نمایش داده می‌شود.
                </p>
              )}

              <div className="UserBalanceGrid">
                <div className="UserBalanceCard">
                  <span>مانده پولی</span>
                  <strong>{formatAmount(user?.moneyBalance)} ریال</strong>
                </div>
                <div className="UserBalanceCard">
                  <span>مانده طلای حساب</span>
                  <strong>{formatAmount(user?.goldBalance)} گرم</strong>
                </div>
                <div className="UserBalanceCard">
                  <span>نام کاربر</span>
                  <strong>{user?.firstName} {user?.lastName}</strong>
                </div>
                <div className="UserBalanceCard">
                  <span>شماره تماس</span>
                  <strong>{user?.phone || "-"}</strong>
                </div>
              </div>
            </>
          )}
        </section>
      </main>
    </div>
  );
}

export default BalancePage;
